'use strict'

import * as dot from 'dot-object'
import * as _ from 'lodash'
import { sanitize } from '@/helpers/sanitize'
import configurazioniService from '@/services/configurazioniService'
import prodottiService from '@/services/prodottiService'
import clientiService from '@/services/clientiService'
import movimentiService from '@/services/movimentiService'
import fidelityService from '@/services/fidelityService'
import scontriniService from '@/services/scontriniService'
import moment from 'moment'

export const creaProdotti = async function (dati, datiDefault, valoriDefault, riferimento, tagliaColore) {

  const aliquoteIva = await configurazioniService.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioniService.getConfigurazione('prodotti_reparti_fiscali', 'reparti')

  const prodotti = dati.filter(x => String(x.codice).length > 0).map(pr => {
    let pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    if (pobj._id) {
      pobj._id = sanitize(pobj._id)
    }    
    pobj.marchio = sanitize(pobj.marchio || '-')
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice || c_desc) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }
    let iva = aliquoteIva.find(x => x.codice === String(_.get(pobj, 'appoggio.aliquota', '')))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(_.get(pobj, 'appoggio.repartoFiscale', '')).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(_.get(pobj, 'appoggio.repartoFiscale', '')))

    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, datiDefault)

    if (iva || reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [],
        reparto: {}
      }
      if (iva) {
        pobj.datiFiscali.aliquoteIva.push({
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        })
      }
      if (reparto) {
        pobj.datiFiscali.reparto = {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    /*     if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    } */
    if (_.get(pobj, 'magazzino.prezzoAcquisto', null)) {
      pobj.magazzino.prezzoAcquisto = +pobj.magazzino.prezzoAcquisto.toFixed(2)
    }
    pobj.magazzino.unitaMisura = pobj.magazzino.unitaMisura || 'n'
    if (['pce', 'pcs', 'pezzi', 'pieces'].includes(pobj.magazzino.unitaMisura)) {
      pobj.magazzino.unitaMisura = 'pz'
    }
    if (['ml', 'lm', 'metri'].includes(pobj.magazzino.unitaMisura)) {
      pobj.magazzino.unitaMisura = 'm'
    }
    if (pobj.prezzo) {
      if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +pobj.prezzo.L1.base.toFixed(2)
      if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +pobj.prezzo.L2.base.toFixed(2)
      if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +pobj.prezzo.L3.base.toFixed(2)
      if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +pobj.prezzo.L4.base.toFixed(2)
      if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +pobj.prezzo.L5.base.toFixed(2)
    }
    if (pobj.ssnn) {
      if (_.get(pobj, 'ssnn.detraibile', false)) {
        // Eventualmente aggiungere le colonne relative a codice detrazione e percentuale
        delete pobj.ssnn
        pobj.datiFiscali.ssnn = {
          detraibile: true,
          codiceDetrazione: 'AD',
          detraibilitaPercentuale: 100
        } 
      } else {
        delete pobj.ssnn
      }
    }
    return pobj
  })
  try {
    if (prodotti && prodotti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 500
        const sub = prodotti.slice(start, end)
        console.log('prodotti:', start, end)
        await prodottiService.creaProdottiMultipliTestBarcode(sub, 'import: ' + riferimento, tagliaColore, false)

        start += 500
      } while (end < prodotti.length)
    }
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaMovimento ordine: ${error}`)
    return []
  }    
}

export const aggiornaGiacenza = async function(dati, magazzino, tagliaColore) {
  const prodottiGiacenza = dati.filter(x => _.get(x, 'appoggio.quantita')).map(pr => {
    const pobj = dot.object({ ...pr })
    // pobj.codice = String(pobj.codice).toLowerCase()
    pobj.codice = sanitize(String(pobj.codice))
    if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    }
    return pobj
  })

  try {
    if (prodottiGiacenza && prodottiGiacenza.length > 0) {
      let start = 0
      let end = 0
      var parametri = {
        magazzino: magazzino,
        segno: '+'
      }
      do {
        end = start + 25
        const sub = prodottiGiacenza.slice(start, end)
        console.log('prodottiGiacenza:', start, end)
        await prodottiService.aggiornaGiacenzaMultipla(parametri, sub, tagliaColore)

        start += 25
      } while (end < prodottiGiacenza.length)
      return true
    }
    return []
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaMovimento ordine: ${error}`)
    return []
  }    
}

// NON USATA
export const creaMovimenti = async function (dati, datiDefault, valoriDefault, numeroMovimento, fornitore, dataMovimento) {
  const aliquoteIva = await configurazioniService.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioniService.getConfigurazione('prodotti_reparti_fiscali', 'reparti')

  const prodotti = dati.map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = String(pobj.codice).toLowerCase()
    if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    }
    let iva = aliquoteIva.find(x => x.codice === pobj.appoggio.aliquota)
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    if (pobj.magazzino.prezzoAcquisto) {
      pobj.magazzino.prezzoAcquisto = +pobj.magazzino.prezzoAcquisto.toFixed(2)
    }
    if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +pobj.prezzo.L1.base.toFixed(2)
    if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +pobj.prezzo.L2.base.toFixed(2)
    if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +pobj.prezzo.L3.base.toFixed(2)
    if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +pobj.prezzo.L4.base.toFixed(2)
    if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +pobj.prezzo.L5.base.toFixed(2)

    return pobj
  })

  const dataJS = moment(dataMovimento, 'YYYY-MM-DD').utcOffset(0, true).format()
  let movimenti = dati.map(pr => {
    const pobj = dot.object(pr)
    pobj.codice = String(pobj.codice).toLowerCase()
    if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    }
    let iva = aliquoteIva.find(x => x.codice === pobj.appoggio.aliquota)
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    } 
    const prezzo = pr.prezzo[valoriDefault.listinoVendita].base
    const acquisto = pr.magazzino.prezzoAcquisto
    return {
      prodotto: {
        codice: (pr.codice + String(pr.varianti.variante1.codice || '') + String(pr.varianti.variante2.codice || '')).toLowerCase(),
        quantita: pr.appoggio.quantita || 0,
        um: pr.magazzino.unitaMisura,
        prezzoUnitario: prezzo,
        prezzo: +(prezzo * (pr.appoggio.quantita || 0)).toFixed(2),
        // aliquota: pr.appoggio.aliquota || datiDefault.datiFiscali.aliquoteIva[0].valore,
        aliquota: pr.datiFiscali.aliquoteIva[0].valore,
        prezzoAcquisto: acquisto,
        valoreacquisto: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2)
      },
      quantita: pr.appoggio.quantita || 0,
      // valore: +(prezzo * pr.appoggio.quantita).toFixed(2),
      valore: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2), // va valutato in base al tipo di movimento fatto
      riferimento: {
        tipo: 'importDati',
        id: String(numeroMovimento).toUpperCase(),
        data: dataJS
      },
      anagrafica: {
        cliente: '', // aggiungere esterno, solo se presente nei dati
        fornitore: {
          codice: fornitore.codice,
          descrizione: fornitore.ragioneSociale
        }
      },
      custom: pr.custom
    }
  })
  const prodottiGiacenza = dati.filter(x => x.appoggio.quantita).map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = String(pobj.codice).toLowerCase()
    if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    }
    pobj.ultimoAcquisto = {
      data: dataJS,
      quantita: pr.appoggio.quantita || 0,
      fornitore: fornitore.codice,
      fornitoreDescrizione: fornitore.ragioneSociale,
      // prezzo: pr.prezzo.L1.base,
      prezzo: pr.magazzino.prezzoAcquisto, // TODO: verificare
      movimento: numeroMovimento
    }
    return pobj
  })
  try {
    if (prodotti && prodotti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 10000
        const sub = prodotti.slice(start, end)
        console.log('prodotti:', start, end)
        await prodottiService.creaProdottiMultipliTestBarcode(sub, 'import: ' + numeroMovimento, true, false)

        start += 10000
      } while (end < prodotti.length)
    }
    var parametri
    movimenti = movimenti.filter(x => x.quantita)
    if (movimenti && movimenti.length > 0) {  // rivedere come prodotti
      const magazzino = valoriDefault.magazzinoMovimento
      const causale = valoriDefault.causaleMovimento
      const causali = await configurazioniService.getConfigurazione('magazzino_causali', 'causali')
      parametri = causali.find(x => x.codice === causale)
      parametri.magazzino = magazzino // TODO: Verificare --> Probabilemente va preso il magazzino selezionato
      
      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = movimenti.slice(start, end)
        console.log('movimenti:', start, end)
        await movimentiService.creaMovimentiMultipli(magazzino, parametri, sub)
        start += 25
      } while (end < movimenti.length)
    }
    if (prodottiGiacenza && prodottiGiacenza.length > 0) {  // rivedere come prodotti
      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = prodottiGiacenza.slice(start, end)
        console.log('prodottiGiacenza:', start, end)
        await prodottiService.aggiornaGiacenzaMultipla(parametri, sub, true) // Parametro taglia/Colore deve arrivare da import

        start += 25
      } while (end < prodottiGiacenza.length)
      return true
    }
    return []
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaMovimento ordine: ${error}`)
    return []
  }
}

export const aggiornaClienti = async function (dati, datiDefault) {
  const elenco = dati.filter(x => String(x.codice).length > 0).map(pr => {
    let pobj = dot.object({ ...pr })
    return pobj
  })
  const ids = dati.filter(x => String(x.codice).length > 0).map(x => x.codice)
  const clienti = await clientiService.getClientiByIds(ids)
  for (let cliente of clienti) {
    const datiCl = dati.find(x => x.codice === cliente._id)
    const elencoCl = elenco.find(x => x.codice === cliente._id)
    const keys = (Object.keys(datiCl)).filter(x => x !== 'codice')
    for (let kk of keys) {
      const nuovo = dot.pick(kk, elencoCl)
      dot.str(kk, nuovo, cliente)
    }
  }
  try {
    if (clienti && clienti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 500
        const sub = clienti.slice(start, end)
        console.log('clienti:', start, end)
        await clientiService.creaClientiMultipli(sub)

        start += 500
      } while (end < clienti.length)
    }
  } catch (error) {
    console.log(`aggiornaClienti: ${error}`)
    return []
  }  

}
export const creaClienti = async function (dati, datiDefault, valoriDefault, riferimento) {
/*   const aliquoteIva = await configurazioniService.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioniService.getConfigurazione('prodotti_reparti_fiscali', 'reparti') */
  const tipologieClienti = await configurazioniService.getConfigurazione('clienti_tipologie', 'tipologie')
  const modalitaPagamento = await configurazioniService.getConfigurazione('documenti_pagamento', 'modalitaPagamento')
  const listini = await configurazioniService.getConfigurazione('listini', 'listini')

  const impoGenerale = await configurazioniService.getConfigurazione('display_generale')
  const creaFidelity = _.get(impoGenerale, 'fidelityCard.creazioneAutomaticaConCliente.abilitato', false)

  for (let d of dati.filter(x => !x.codice)) {
    d.codice = await creaCodiceCliente(d.ragioneSociale)
  }

  const clienti = dati.filter(x => String(x.codice).length > 0).map(pr => {
    let pobj = dot.object({ ...pr })
    _.merge(pobj, datiDefault)
    pobj.codice = sanitize(pobj.codice)
    if (pobj._id) {
      pobj._id = sanitize(pobj._id)
    }
    pobj.amministrativi = pobj.amministrativi || {}
    pobj.amministrativi.cliente = _.get(pobj, 'amministrativi.cliente', false) === true || _.get(pobj, 'amministrativi.cliente', 'false') === 'true'
    pobj.amministrativi.fornitore =  _.get(pobj, 'amministrativi.fornitore', false) === true || _.get(pobj, 'amministrativi.fornitore', 'false') === 'true'
    
    if (pobj.amministrativi.tipologiaCliente) {
      const tipologia = tipologieClienti.find(x => x.codice === pobj.amministrativi.tipologiaCliente.toLowerCase())
      if (tipologia) {
        pobj.amministrativi.tipologiaCliente = tipologia
        if (tipologia.listino) {
          const listino = listini.find(x => x.codice === tipologia.listino)
          if (listino) {
            pobj.amministrativi.listino = listino
          }
        }
      }
    }
    if (pobj.amministrativi.pagamento) {
      const modalita = modalitaPagamento.find(x => x.codice === pobj.amministrativi.pagamento.dettaglio.modalita.toUpperCase())
      if (modalita) {
        pobj.amministrativi.pagamento = {
          condizioni : 'TP02',
          dettaglio: {
            modalita : modalita.codice
          }
        }
        if (modalita.giorniPagamento && modalita.giorniPagamento.length > 1) {
          pobj.amministrativi.pagamento.condizioni = 'TP01'
        }
      }
    }
    if (pobj.recapiti && pobj.recapiti.length === 1) {
      pobj.recapiti[0].tipo = {
        codice: "principale",
        descrizione: "Sede"
      }
    }

/*     pobj.marchio = sanitize(pobj.marchio)
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    } */
/*     for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice || c_desc) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    } */
/*     let iva = aliquoteIva.find(x => x.codice === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    if (pobj.magazzino.prezzoAcquisto) {
      pobj.magazzino.prezzoAcquisto = +pobj.magazzino.prezzoAcquisto.toFixed(2)
    }
    pobj.magazzino.unitaMisura = pobj.magazzino.unitaMisura || 'n' */

/*     if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +pobj.prezzo.L1.base.toFixed(2)
    if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +pobj.prezzo.L2.base.toFixed(2)
    if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +pobj.prezzo.L3.base.toFixed(2)
    if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +pobj.prezzo.L4.base.toFixed(2)
    if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +pobj.prezzo.L5.base.toFixed(2)
    if (pobj.ssnn) {
      if (_.get(pobj, 'ssnn.detraibile', false)) {
        // Eventualmente aggiungere le colonne relative a codice detrazione e percentuale
        delete pobj.ssnn
        pobj.datiFiscali.ssnn = {
          detraibile: true,
          codiceDetrazione: 'AD',
          detraibilitaPercentuale: 100
        } 
      } else {
        delete pobj.ssnn
      }
    } */
    return pobj
  })
  try {
    if (clienti && clienti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 500
        const sub = clienti.slice(start, end)
        console.log('clienti:', start, end)
        await clientiService.creaClientiMultipli(sub)

        start += 500
      } while (end < clienti.length)

      if (creaFidelity) {
        const idCassa = impoGenerale.stampante.progressivo_stampante
        const impCard = impoGenerale.fidelityCard
        const payload = _.get(impCard, 'defaultNonPresente', {})
        _.set(payload, 'raccoltaPunti.dallaData', new Date())
        for (let cl of clienti) {
          const cliente = { codice: cl.codice, ragioneSociale: cl.ragioneSociale }
          await fidelityService.creaFidelityCardCliente(idCassa, payload, cliente)
        }
      }

    }
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`caricamento clienti: ${error}`)
    return []
  }    
}

const creaCodiceCliente = async function(ragSoc) {
  const impostazioni = await configurazioniService.getConfigurazione('backoffice', 'impostazioni')
  const tipoNumeratore = impostazioni.clienti.tipoNumeratore
  var numeratore
  if (tipoNumeratore === '_') {
    const pattern = /[^a-zA-Z0-9-]+/gi
    numeratore = ragSoc.trim().replace(/\s\s+/g, ' ').replace(pattern, '_').toLowerCase()
  } else {
    numeratore = await configurazioniService.getNumeratore(tipoNumeratore, true)
  }
  return numeratore
}

export const creaScontrini = async function (dati, datiDefault, valoriDefault, riferimento) {
    const scontrini = dati.filter(x => String(x['fiscale.ricerca.documento']).length > 0).map(pr => {
      let pobj = dot.object({ ...pr })
      _.merge(pobj, datiDefault)
      pobj.numero = moment(pobj.fiscale.data).format() + Math.round(Math.random() * 1000)
      return pobj
    })
    try {
      for (let s of scontrini) {
        // console.log(s)
        await scontriniService.creaScontrinoCompleto(s)
      }
      // console.log(scontrini[0])
      // await scontriniService.creaScontrinoCompleto(scontrini[0])
    } catch (error) {
      console.log(`caricamento scontrini: ${error}`)
      return []
    }    
  }
